export default __webpack_public_path__ + "static/media/samsung.8e670bfa.png";